import { useState, useEffect } from "react";
import { NavigationGuardProvider } from "@/contexts/navigation-guard-context";
import { FormBuilder } from "@/modules/form/components/form-builder";
import { useAuth } from "@/modules/auth";
import { useBrands } from "@/modules/brand";
import { useBrandKits } from "@/modules/brand/hooks/use-brand-kits";
import { useTags } from "@/modules/tag/hooks/use-tags";
import type { FlowSection, Question } from "@/modules/form/components/form-builder/types";
import type { TrackedChanges } from "@/modules/form/components/form-builder/hooks/use-form-builder-state";

export default function FormBuilderDemoPage() {
	const [isSaving, setIsSaving] = useState(false);
	const { currentWorkspaceId } = useAuth();
	const { brands } = useBrands();
	const { brandKit, viewBrandKit } = useBrandKits();
	const { tags, indexTags } = useTags();

	// Get current brand info
	const currentBrand = brands?.find((b) => b.id === currentWorkspaceId);
	const brandName = currentBrand?.name ?? "Your Brand";

	// Fetch brand kit on mount
	useEffect(() => {
		if (currentWorkspaceId) {
			viewBrandKit(currentWorkspaceId);
		}
	}, [currentWorkspaceId, viewBrandKit]);

	// Fetch tags on mount
	useEffect(() => {
		if (currentWorkspaceId) {
			indexTags(currentWorkspaceId);
		}
	}, [currentWorkspaceId, indexTags]);

	const handleSave = async (data: {
		formTitle: string;
		sections: FlowSection[];
		questions: Question[];
		autoApproveTestimonials: boolean;
		selectedTagIds: string[];
		theme: "light" | "dark" | "system-default";
		trackedChanges: TrackedChanges;
	}) => {
		setIsSaving(true);
		console.log("Saving form data:", data);

		// Simulate API call
		await new Promise((resolve) => setTimeout(resolve, 1500));

		console.log("Form saved successfully!");
		setIsSaving(false);
	};

	return (
		<NavigationGuardProvider>
			<FormBuilder
				formTitle="Feedback Collection Form 1"
				brandName={brandName}
				brandLogo={brandKit?.logo_icon_with_label_url ?? null}
				brandKit={brandKit}
				tags={tags ?? []}
				onSave={handleSave}
				isLoading={isSaving}
				backUrl={`/${currentWorkspaceId}/forms`}
			/>
		</NavigationGuardProvider>
	);
}
